<div class="impersonate-dialog">
  <div class="dialog-header">
    <h2>{{ 'impersonate.title' | translate }}</h2>
    <p class="text-surface-500">{{ 'impersonate.subtitle' | translate }}</p>
  </div>

  <div class="dialog-content">
    <!-- Search Section -->
    <div class="search-section mb-4">
      <label class="block text-sm font-semibold mb-2">
        {{ 'impersonate.search_user' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <div class="search-box">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          [(ngModel)]="searchQuery"
          (input)="onSearchChange()"
          [placeholder]="'impersonate.search_placeholder' | translate"
          class="search-input"
        />
      </div>
      <p-progressSpinner
        *ngIf="loading"
        [style]="{ width: '100%', marginTop: '1rem' }"
        strokeWidth="4"
        fill="none"
        animationDuration=".5s"
      ></p-progressSpinner>
    </div>

    <!-- Selected User Display -->
    <div *ngIf="selectedUser" class="mb-4">
      <p-card class="selected-user-card">
        <ng-template pTemplate="header">
          <div class="selected-user-header">
            <i class="pi pi-check-circle text-green-500 text-lg"></i>
            <span>{{ 'impersonate.selected_user' | translate }}</span>
            <p-button
              class="clear-selection-button"
              [text]="true"
              [rounded]="true"
              severity="secondary"
              icon="pi pi-times"
              [pTooltip]="'impersonate.change_user' | translate"
              tooltipPosition="left"
              (click)="clearSelection()"
            ></p-button>
          </div>
        </ng-template>
        <div class="selected-user-content">
          <p-avatar
            *ngIf="selectedUser.profilePictureBase64"
            [image]="'data:image/jpg;base64,' + selectedUser.profilePictureBase64"
            [size]="'large'"
            shape="circle"
          ></p-avatar>
          <p-avatar
            *ngIf="!selectedUser.profilePictureBase64"
            [label]="(selectedUser.firstname?.charAt(0) ?? '') + (selectedUser.lastname?.charAt(0) ?? '')"
            [size]="'large'"
            shape="circle"
          ></p-avatar>
          <div class="user-info">
            <p class="user-name">{{ selectedUser.firstname }} {{ selectedUser.lastname }}</p>
            <p class="user-email">{{ selectedUser.mail }}</p>
            <p *ngIf="selectedUser.oidcIdentifier" class="user-oidc">{{ selectedUser.oidcIdentifier }}</p>
          </div>
        </div>
      </p-card>
    </div>

    <!-- Search Results -->
    <div *ngIf="searchQuery.trim().length > 0 && searchResults.length > 0 && !selectedUser" class="search-results-section">
      <h3 class="text-sm font-semibold mb-3">{{ 'impersonate.search_results' | translate }}</h3>
      <div class="search-results-list">
        <div
          *ngFor="let user of searchResults"
          (click)="selectUser(user)"
          class="search-result-item"
        >
          <p-avatar
            *ngIf="user.profilePictureBase64"
            [image]="'data:image/jpg;base64,' + user.profilePictureBase64"
            [size]="'normal'"
            shape="circle"
          ></p-avatar>
          <p-avatar
            *ngIf="!user.profilePictureBase64"
            [label]="(user.firstname?.charAt(0) ?? '') + (user.lastname?.charAt(0) ?? '')"
            [size]="'normal'"
            shape="circle"
          ></p-avatar>
          <div class="search-result-user-info">
            <p class="text-sm font-medium">{{ user.firstname }} {{ user.lastname }}</p>
            <p class="text-xs text-surface-500">{{ user.mail }}</p>
            <p *ngIf="user.oidcIdentifier" class="text-xs text-surface-500">{{ user.oidcIdentifier }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent Impersonations -->
    <div *ngIf="recentImpersonations.length > 0 && !selectedUser && searchQuery.trim().length === 0" class="recent-section">
      <h3 class="text-sm font-semibold mb-3">{{ 'impersonate.recent' | translate }}</h3>
      <div class="recent-list">
        <div
          *ngFor="let user of recentImpersonations"
          (click)="selectRecentImpersonation(user)"
          class="recent-item"
        >
          <p-avatar
            *ngIf="user.profilePictureBase64"
            [image]="'data:image/jpg;base64,' + user.profilePictureBase64"
            [size]="'normal'"
            shape="circle"
          ></p-avatar>
          <p-avatar
            *ngIf="!user.profilePictureBase64"
            [label]="(user.firstname?.charAt(0) ?? '') + (user.lastname?.charAt(0) ?? '')"
            [size]="'normal'"
            shape="circle"
          ></p-avatar>
          <div class="recent-user-info">
            <p class="text-sm font-medium">{{ user.firstname }} {{ user.lastname }}</p>
            <p class="text-xs text-surface-500">{{ user.mail }}</p>
            <p *ngIf="user.oidcIdentifier" class="text-xs text-surface-500">{{ user.oidcIdentifier }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <p-button
      [label]="'generics.cancel' | translate"
      [severity]="'secondary'"
      [text]="true"
      (click)="cancel()"
    ></p-button>
    <p-button
      [label]="'generics.impersonate' | translate"
      [disabled]="!selectedUser || loading"
      [loading]="loading"
      (click)="impersonate()"
    ></p-button>
  </div>
</div>
